<template>
  <v-layout>
    <v-flex >
      <panel :title="user.last_name">
        <v-form ref="form">
        <v-text-field
          :label="$t('userGenerics.userId')"
          required
          readonly
          disabled
          :loading = "loading"
          :rules="[required]"
          v-model="user.id"
        ></v-text-field>

        <v-text-field
          :label="$t('userGenerics.email')"
          readonly
          disabled
          :rules="[required]"
          v-model="user.username"
        ></v-text-field>
        <v-flex row>
        <v-text-field
          :label="$t('userGenerics.firstName')"
          required
          :rules="[required]"
          v-model="user.first_name"
        ></v-text-field>

        <v-text-field
          :label="$t('userGenerics.lastName')"
          required
          :rules="[required]"
          v-model="user.last_name"
        ></v-text-field>
        </v-flex>

        <v-text-field
          :label="$t('userDetail.phoneNum')"
          v-model="user.phone_number"
        ></v-text-field>
        
        <!-- <v-select
            v-model="user.buildingID"
            :items="buildings"
            item-text="buildingName"
            item-value="buildingID"
            :label="$tc('barn', 1)"
        ></v-select> -->
        <v-select
            v-model="user.role_type"
            :items="roles"
            item-text="role_type"
            item-value="role_name"
            :label="$tc('role', 1)"
            read-only
        ></v-select>
        <v-switch :label="$t('userDetail.enabled')" v-model="user.enabled"></v-switch>
        <div class="danger-alert" v-if="error">
        {{error}}
      </div>
      <v-layout class="modal-button-row">
        <v-btn
          dark
          block
          class="button-delete button-modal"
          @click="this.delete">
          {{$t('actions.delete')}}
        </v-btn>
        <v-btn
          dark
          block
          class="secondary button-modal"
          @click="save">
          {{$t('actions.saveModifications')}}
        </v-btn>
      </v-layout>
      </v-form>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import UsersService from '@/services/UsersService'
import CompaniesService from '@/services/CompaniesService'
import BuildingsApi from '@/api/buildings-api'
import { RoleTypes } from './../constants/role_types'

export default {
  props: ['clickedId'],
  data () {
    return {
      user: {
        userID: null,
        email: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        buildingID: null,
        role: {},
        Company: {},
        enabled: null,
        Building: {}
      },
      error: null,
      required: (value) => !!value || 'Required.',
      roles: Object.keys(RoleTypes).filter((role)=>role !== RoleTypes.SuperAdmin).map((key) => ({
        role_type: RoleTypes[key],
        role_name: RoleTypes[key]
      })),
      buildings: [],
      companies: [],
      loading: false
    }
  },
  methods: {
    async save () {
      this.error = null
      if (this.$refs.form.validate()) {
        this.error = null
        try {
          this.user.enabled = this.user.enabled ? 1 : 0
          await UsersService.put(this.user)
          this.$emit('close')
        } catch (err) {
          this.error = err.response.statusText
          console.log(err)
        }
      }
    },
    async delete () {
      this.error = null
      try {
        await UsersService.delete(this.user.id)
        this.$emit('close')
      } catch (err) {
        this.error = err.response.statusText
        console.log(err)
      }
    }
  },
  watch: {
    clickedId: async function () {
      this.error = null
      this.loading = true
      try {
        const userID = this.clickedId
        let [user, buildings, roles, companies] = await Promise.all([UsersService.show(userID), BuildingsApi.list()])
        this.user = user.data
      } catch (err) {
        console.log(err)
        this.error = err.response
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EditUser.vue